import ChangeWorkspaceOwnership from './ChangeWorkspaceOwnership';
export default ChangeWorkspaceOwnership;
